import { ViewType } from '@/router'

import { SidebarStore } from '../SidebarStore'

export async function sidebarSetRightView(view: ViewType) {
  const { sidebarStore } = SidebarStore.get()

  await sidebarStore.dispatch(async (state) => {
    state.rightView = view
  })
}
